<template>
    <div>
        <Card class="p-col p-mr-5 p-ml-5">
            <template #content>

                <DataTable
                        sortMode="multiple"
                        removableSort
                        :selection.sync="selectedItems"
                        dataKey="id"
                        editMode="cell"
                        :filters="filters"
                        sortField="lastname"
                        style="width: 98% !important;"
                        :rowClass="rowClass"
                        :value="descriptionsSorted"
                        :paginator="true"
                        :resizableColumns="false"
                        :loading="isLoading"

                        columnResizeMode="fit"
                        class="
          p-datatable-customers
          p-datatable-sm
          p-datatable-gridlines
          p-datatable-striped
        "
                        :rows="40"
                        stateStorage="session"
                        stateKey="descriptions-list-table"
                        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                        :rowsPerPageOptions="[5, 10, 20, 50]"
                        currentPageReportTemplate="מציג {first} עד {last} מתוך {totalRecords}"
                >
                    <template #header>
                        <div class="p-p-2 table-header">
                            <div class="p-m-1 p-d-inline-flex">
                                <h1 style="text-align: center"><i style=" transform: scale(1.7); "
                                                                  class="p-p-3 pi pi-th-large"></i>| בנק הערות</h1>
                            </div>
                            <div v-if="user.role !== 'ADMIN'" class="p-m-1 p-d-inline-flex">
                                <p  style="text-align: center; color: red">*ניתן לערוך ולמחוק רק הערות שאתה יצרת</p>
                            </div>

                            <div class="p-d-flex">
              <span class="p-mr-2 p-input-icon-left">
                <i class="pi pi-search"/>
                <InputText
                        v-model="filters['global']"
                        placeholder="חיפוש ראשי"
                />
              </span>
                                <Button
                                        v-tooltip.top="'מחיקה'"
                                        v-if="canDeleteDescriptions() && selectedItems.length > 0 && selectedItems.length < 5"
                                        icon="pi pi-trash"
                                        class="p-mr-2 p-button-danger "
                                        @click="deleteDescriptions()"
                                />
                                <Button
                                        v-tooltip.top="'ניתן למחוק\n רק פריטים השייכים לך ועד 5 פריטים'"
                                        v-if="!canDeleteDescriptions() || selectedItems.length >= 5"
                                        icon="pi pi-trash"

                                        class="p-mr-2 p-button-secondary"
                                />
                                <Button
                                        v-tooltip.top="'הוספה'"
                                        icon="pi pi-plus"
                                        class="p-mr-2 p-button-success"
                                        @click="isDialogAdd = true"
                                />
                            </div>
                        </div>
                    </template>
                    <Column selectionMode="multiple" headerStyle="width: 3em"></Column>

                    <template #loading> טוען נתונים מהמערכת, אנא המתן...</template>

                    <Column
                            headerStyle="width: 12%; text-align: rtl"
                            bodyStyle="background-color: #f1f1f1; text-align: right;"
                            field="subjectType"
                            header="סוג דיווח"
                            filterMatchMode="in"
                            filterField="subjectType"
                            sortable
                            sortField="subjectType"
                    >

                        <template #body="slotProps">
                            <div>
                                {{ getNameOfReportType(slotProps.data.subjectType) }}
                            </div>
                        </template>
                    </Column>
                    <Column
                            headerStyle="width: 12%; text-align: rtl"
                            bodyStyle="background-color: #f1f1f1; text-align: right;"
                            field="subjectId"
                            header="נושא"
                            filterMatchMode="in"
                            filterField="subjectId"
                            sortable
                            sortField="subjectId"
                    >

                        <template #body="slotProps">
                            <div>
                                {{ getNameOfSubjectType(slotProps.data.subjectType, slotProps.data.subjectId) }}
                            </div>
                        </template>
                    </Column>
                    <Column
                            headerStyle="text-align: rtl"
                            bodyStyle="text-align: right;"
                            field="description"
                            header="תיאור"
                            filterMatchMode="in"
                            filterField="description"
                            sortable
                            sortField="description"
                    >

                        <template #body="slotProps">
                            <div>
                                {{ slotProps.data.description }}
                            </div>
                        </template>
                        <template #editor="slotProps">
                            <Textarea
                                    v-if="isMyDescription(slotProps.data)"
                                    style="    width: 100%;"
                                    autoResize="true"
                                    class="p-inputtextarea p-inputtext p-component"
                                    :value="slotProps.data.description"
                                    @change="onCellEditComplete($event, slotProps)"
                            />
                            <div v-else>
                                {{ slotProps.data.description }}
                            </div>
                        </template>
                    </Column>
                </DataTable>
            </template>
        </Card>
        <add-Dialog
                :show="isDialogAdd"
                v-on:addItem="addItem"
                v-on:closeDialog="isDialogAdd = false"
        >
        </add-Dialog>
    </div>
</template>

<script>
import {deleteDescription, getAllDescriptions, postDescription, updateDescription} from "@/views/report/Report";
import addDialog from "./addDescriptionDialog"
import {mapState} from "vuex";

const TOPICS_TYPE = "topicsScores"
const BEHAVIORS_TYPE = "behaviorScores"
const PRESENCES_TYPE = "presenceScores"
const NOTE_TYPE = "reportNote"
const reportTypesConsts = [
    {
        value: BEHAVIORS_TYPE,
        hebrewName: "הליכות"
    },
    {
        value: TOPICS_TYPE,
        hebrewName: "מקצוע"
    },
    {
        value: PRESENCES_TYPE,
        hebrewName: "נוכחות"
    }, {
        value: NOTE_TYPE,
        hebrewName: "הערת מחנך"
    },
]
export default {
    name: "DescriptionsReport",
    components: {
        addDialog
    },
    data() {
        return {
            descriptions: [],
            selectedItems: [],
            isDialogAdd: false,
            isLoading: false,
            filters: {},
            reportTypes: reportTypesConsts,
        }
    },
    mounted() {
        this.getAllDescriptions()
    },
    methods: {
        async deleteDescriptions() {
            const itemsId = this.selectedItems.map(item => item.id)
            try {
                await deleteDescription(itemsId)
                itemsId.forEach(id => {
                    const index = this.descriptions.findIndex(desc => desc.id === id)
                    this.selectedItems = []
                    const descriptions = [...this.descriptions]
                    descriptions.splice(index, 1)
                    this.descriptions = [...descriptions]
                })

                this.openNotification(
                    "success",
                    `מעולה`,
                    ` מחקנו ${itemsId.length} הערות `
                );
            } catch (e) {
                this.openNotification(
                    "danger",
                    `אופס`,
                    `לא הצלחנו למחוק`
                );
            }
        },
        async addItem(objToSave) {
            try {
                const {data} = await postDescription(objToSave)
                this.descriptions.push(data)
                this.openNotification(
                    "success",
                    `מעולה`,
                    `׳${objToSave.description}׳ נשמר בבנק ההערות `
                );
            } catch (e) {
                this.openNotification(
                    "danger",
                    `אופס`,
                    `לא הצלחנו לשמור את ההערה`
                );
            }
        },
        async getAllDescriptions() {
            try {
                this.isLoading = true
                const {data} = await getAllDescriptions()
                this.descriptions = data
                this.isLoading = false

            } catch (e) {
                this.openNotification(
                    "danger",
                    `אופס`,
                    `לא הצלחנו לטעון את בנק ההערות`
                );
            }
        },
        getNameOfReportType(subjectType) {
            return this.reportTypes.find(reportType => reportType.value === subjectType)?.hebrewName || ''
        },
        getNameOfSubjectType(reportType, subjectId) {
            if (reportType === TOPICS_TYPE) {
                return this.subjectLesson?.find(subId => subId.id === subjectId)?.hebrewName || ''
            } else if (reportType === BEHAVIORS_TYPE) {
                return this.subjectTracing?.find(subId => subId.id === subjectId)?.hebrewName || ''
            } else if (reportType === PRESENCES_TYPE) {
                return '-'
            }
        },
        async onCellEditComplete(event, slotProps) {
           const index = this.descriptions.findIndex(desc => desc.id === slotProps.data.id)
            const newValue = event.target.value
            const oldValue = this.descriptions[index].description
            const objToSave = {...slotProps.data, description: newValue}
            const a = [...this.descriptions]
            a[index].description = newValue
            this.descriptions = [...a]
            try {
                await updateDescription(objToSave)
            } catch (e) {
                    this.descriptions[index].description = oldValue
                this.openNotification(
                    "danger",
                    `אופס`,
                    `לא הצלחנו לעדכן את ההערה`
                );
            }
        },
        openNotification(
            color,
            title,
            text,
            position = "right-left",
            duration = 3000
        ) {
            this.$vs.notification({color, position, title, text, duration, progress: 'auto'});
        },
        rowClass(row) {
            return this.isMyDescription(row) ? '' : 'non-edit';
        },
        isMyDescription(description) {
            return this.user.role === "ADMIN" ? true : description.user === this.user.id
        },
        canDeleteDescriptions() {
            return this.user.role === "ADMIN" ? true : !this.selectedItems.some(item => item.user !== this.user.id)
        }
    },
    computed: {
        descriptionsSorted(){
          return this.descriptions.sort((a,b) => {
              if (a.user === this.user.id){
                  return -1
              } else if (a.user !== this.user.id){
                  return 1
              } else {
                  return 0
              }
          })
        },
        ...mapState(["intro", "pupils", "user", "gradeOptions", "subjectLesson",
            "presenceStatus",
            "subjectTracing"]),


    },

}
</script>

<style scoped>
>>> .non-edit {
    background-color: #f1f1f1 !important;
}

>>> .non-edit .p-selection-column .p-checkbox .p-checkbox-box {
    background-color: #f1f1f1 !important;
    border: #f1f1f1 !important;
     cursor: auto;
}>>> .non-edit .p-selection-column .p-checkbox .p-checkbox-box:hover {
    border-color: #f1f1f1 !important;
     cursor: auto;
}
</style>